<template>
    <div class="body">
         <el-table
        :data="data"
        style="width: 100%">
            <el-table-column
                prop="id"
                label="编号"
                width="180">
            </el-table-column>
            <el-table-column
                prop="packageId"
                label="支付类型"
                width="180">
                <template slot-scope="sort">
                        <span v-if="sort.row.packageId!=null" style="color:green">购买套餐</span>
                        <span v-else style="color:#5a78b3">监测支付</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="orderNo"
                label="订单编号">
            </el-table-column>
            <el-table-column
                :format="timestampToTime"
                prop="finishTime"
                label="支付时间">
            </el-table-column>

            <el-table-column
             width="80"
             label="操作">
                <!-- @click="handleEdit(scope.$index, scope.row)" -->
                <template slot-scope="scope">
                    <el-button
                    size="mini"
                    @click="details(scope.row.id)"
                    >详情</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>



<script>
import {orderListApi} from '@/service/allApi'
export default {
    data(){
        return{
            data: []
        }
    },
    created(){
        this.orderList();
    },

    methods:{
       async orderList(){
           var res = await orderListApi();
            if(res.data.code==100){
                for(var i=0;i<res.data.list.length;i++){
                    res.data.list[i].finishTime = this.timestampToTime(res.data.list[i].finishTime)
                    // alert(res.data.list[i].packageId)
                }
                this.data = res.data.list
            }else{
                alert(res.data.msg)
            }
        },
        timestampToTime:function (value) {
            //var date = new Date(row.cjsj) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            // console.log(value)
            var date = new Date(value)
            var Y = date.getFullYear() + '年'
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '月'
            var D = date.getDate()-1 + '日 '
            var h = date.getHours()+10 + ':'
            var m = date.getMinutes() + ':'
            var s = date.getSeconds()     

            // console.log(date)
            // console.log(Y+M+D+h+m+s);
            return Y+M+D+h+m+s
        },
        details(a){
            // alert(a)
            var data =  this.data[a-1]
            window.location.href = "/orderDetails?data=" + JSON.stringify(data)
        }
    }
}
</script>


<style scoped>
.body{
    padding-left: 20px;
    padding-right: 2px;
}
</style>


// WEBPACK FOOTER //
// src/components/iframe/OrderList.vue